import colors from '_containers/Theme/corporate/colors';

export default {
  background: colors.all.brandPrimary3,
  color: colors.all.neutralWhite,
  cutoutBackground: colors.all.neutralBlack,
  subtitleColor: colors.all.neutral75,
};
